import { api } from '@/fsd/shared/api';
import { transformAcceptancesListFilters } from '../../lib/helpers/transformAcceptancesListFilters';

interface IPrams {
  filters?: any;
  sorted?: any;
  metaData: any;
}

export const fetchAcceptancesList = async ({
  filters = {},
  sorted = {},
  metaData,
}: IPrams) => {
  const transformedFilters = transformAcceptancesListFilters(filters);

  const requestData = {
    sorted,
    filters: transformedFilters,
    paginator: {
      page_current: metaData.current_page,
      page_size: metaData.page_size,
    },
  };


  const json = await api.post(`/api/v1/purchase/acceptance/list/`, {
    body: requestData,
  });


  return {
    data: json.data.length > 0 ? json.data : [],
    meta: json.meta,
  };
};
